<!--Start topbar header-->
<header class="topbar-nav">
	<nav id="header-setting" class="navbar navbar-expand fixed-top">
		<div id="toggle_menu_icon" class="toggle-menu" (click)="toggleSidebar()"> <i class="zmdi zmdi-menu"></i>
		</div>

		<div class="logo_title">
			<h5 class="m-0 pl-3 text-white">KOTA MUNICIPAL CORPORATION</h5>
		</div>
		
		<!-- <div style="margin-left: 20px;">
			<img src="assets/images/new_logo1.png" height="40px" width="100px" alt="">
		</div> -->
		
		<!-- <div class="search-bar flex-grow-1">
			<div class="input-group">
				<div class="input-group-prepend search-arrow-back">
					<button class="btn btn-search-back" type="button"><i class="zmdi zmdi-long-arrow-left"></i>
					</button>
				</div>
				<input type="text" class="form-control" placeholder="search">
				<div class="input-group-append">
					<button class="btn btn-search" type="button"><i class="zmdi zmdi-search"></i>
					</button>
				</div>
			</div>
		</div> -->
		<ul class="navbar-nav align-items-center right-nav-link ml-auto">
			<li class="nav-item dropdown search-btn-mobile">
				<a class="nav-link position-relative" href="javascript:;"> <i class="zmdi zmdi-search align-middle"></i>
				</a>
			</li>
			
			<!-- notification icon-->
			<!-- <li ngbDropdown class="nav-item dropdown-lg">
				<button id="helpdesk" [routerLink]="['/pages/help-desk']" class="btn btn-link" style="text-transform: capitalize;color: white;text-decoration: none;">Helpdesk</button>
				<a id="helpdesk" [routerLink]="['/pages/help-desk']"><span><img src="assets/images/help_desk.png" style="height:40px; width:80px;" class="img-circle"></span></a>
			</li>  -->

			<!-- DOB Reaminder Modal -->
			<!-- <li ngbDropdown class="nav-item dropdown-lg" >
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic0" ngbDropdownToggle > 
				<i class="fa fa-birthday-cake" aria-hidden="true" ></i>
				<span *ngIf="totalBirthdayNotification==0" class="bg-info text-white badge-up" >{{totalBirthdayNotification}}</span>
				<span *ngIf="totalBirthdayNotification!=0" class="bg-danger text-white badge-up" >{{totalBirthdayNotification}}</span>
				</a>
				<div style="min-width: 400px; max-height: 400px; overflow: scroll;" ngbDropdownMenu aria-labelledby="dropdownBasic0" class="dropdown-menu-right">
					<ul class="list-group list-group-flush" *ngFor="let bdAlert of birthdayRowData;">
						<li class="list-group-item" style="padding: 5px;">
							<a data-toggle="modal" data-target="#empRemainderModal" (click)="GoToBirthdayAlertReport(bdAlert)">
								<div class="media">
									<div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-5.png" alt="user avatar">
										<i class="zmdi zmdi-cake fa-3x mr-2 ml-1 text-info"></i>
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">{{bdAlert.employeeNo}} {{bdAlert.firstName}} {{bdAlert.lastName}}</h6>
										<p class="msg-info">Happy Birthday.</p> 
										<small>{{bdAlert.dob}}</small>
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>

			</li>  -->
			
			<!-- Message of blackout person-->
			<li ngbDropdown class="nav-item dropdown-lg" *ngIf="roleId==0 || roleId==1">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic1" ngbDropdownToggle> 
					<i class="zmdi zmdi-comment-outline align-middle"></i>
					<span *ngIf="totalBlackoutNotification==0" class="bg-custom text-white badge-up" >{{totalBlackoutNotification}}</span>
					<span *ngIf="totalBlackoutNotification!=0" class="bg-danger text-white badge-up" >{{totalBlackoutNotification}}</span>
					
				</a>
				<div style="min-width: 400px; max-height: 400px; overflow: scroll;" ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
					<ul class="list-group list-group-flush" *ngFor="let boAlert of blackoutRowData;">
						<!-- <li class="list-group-item d-flex justify-content-between align-items-center">New Messages <a href="javascript:;" class="extra-small-font">Clear All</a>
						</li> -->
						<li class="list-group-item" style="padding: 5px;">
							<a data-toggle="modal" data-target="#blackoutModal" (click)="GoToBlackoutAlertReport(boAlert)">
								<div class="media">
									<div class="avatar">
										<!-- <img class="align-self-start mr-3" src="assets/images/avatars/avatar-5.png" alt="user avatar"> -->
										<i class="zmdi zmdi-account-circle fa-3x mr-2 ml-1 text-info"></i>
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">{{boAlert.employeeNo[0]}} {{boAlert.firstName[0]}} {{boAlert.lastName[0]}}</h6>
										<p class="msg-info">Internal app closed.</p> 
										<small>{{boAlert.lastBlackOutTime | date:'HH:mm a'}} to {{boAlert.currentBlackOutTime | date:'HH:mm a'}} ({{boAlert.blackOutTimeHours}} hours, {{boAlert.blackOutTimeMinutes}} minutes)</small>
									</div>
								</div>
							</a>
						</li>
						<!-- <li class="list-group-item text-center"><a href="javaScript:;">See All Messages</a>
						</li> -->
					</ul>
				</div>
			</li>

			<li ngbDropdown class="nav-item dropdown-lg" *ngIf="roleId==0 || roleId==1">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic2" ngbDropdownToggle> 
					<i class="zmdi zmdi-notifications-active align-middle"></i>
					<span *ngIf="totalNotification==0" class="bg-custom text-white badge-up" >{{totalNotification}}</span>
					<span *ngIf="totalNotification!=0" class="bg-danger text-white badge-up" >{{totalNotification}}</span>
				</a>
				<div style="min-width: 400px; max-height: 400px; overflow: scroll;" ngbDropdownMenu aria-labelledby="dropdownBasic2" class="dropdown-menu-right">
					<ul class="list-group list-group-flush" *ngFor="let alert of rowData;">
						<!-- <li class="list-group-item d-flex justify-content-between align-items-center">New Notifications
							<a href="javascript:;" class="extra-small-font">Clear All</a>
						</li> -->
						<li class="list-group-item" *ngIf="alert.serviceId>=0">
							<a data-toggle="modal" data-target="#serviceModal" (click)="GoToServiceAlertReport(alert)" style="text-decoration: none; cursor: pointer;">
								<div class="media"> <i class="zmdi zmdi-bus fa-2x mr-3 text-info"></i>
									<div class="media-body">
										<h6 class="mt-0 msg-title">{{alert.deviceName}} (Running KM : {{alert.runningKm}})</h6>
										<p class="msg-info"><b> {{alert.messages}} </b></p>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item" *ngIf="alert.serviceId==null && alert.employeeId!=0">
							<a data-toggle="modal" data-target="#myModal" (click)="GoToDocumentExpiryAlertReport(alert.employeeId,'',alert.documentName,alert.expiryDate,alert.days,'isSeen')" style="text-decoration: none; cursor: pointer;">
								<div class="media"> <i class="zmdi zmdi-accounts fa-2x mr-3 text-info"></i>
									<div class="media-body">
										<h6 class="mt-0 msg-title">{{alert.employeeNo}} - {{alert.employeeName}} ({{alert.employeeContact}})</h6>
										<p class="msg-info" *ngIf="alert.isSeen=='false'"><b> {{alert.messages}} </b></p>
										<p class="msg-info" *ngIf="alert.isSeen!='false'"> {{alert.messages}} </p>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item" *ngIf="alert.serviceId==null && alert.employeeId==0">
							<a data-toggle="modal" data-target="#myModal" (click)="GoToDocumentExpiryAlertReport(0,alert.vehicleId,alert.documentName,alert.expiryDate,alert.days,'isSeen')" style="text-decoration: none; cursor: pointer;">
									<div class="media"> <i class="zmdi zmdi-subway fa-2x mr-3 text-danger"></i>
									<div class="media-body">
										<h6 class="mt-0 msg-title">{{alert.vehicleName}} ({{alert.documentName}})</h6>
										<p class="msg-info" *ngIf="alert.isSeen=='false'"><b> {{alert.messages}} </b></p>
										<p class="msg-info" *ngIf="alert.isSeen!='false'"> {{alert.messages}} </p>
									</div>
								</div>
							</a>
						</li>
						
						<!-- <li class="list-group-item text-center">
							<a href="javaScript:;">See All Notifications</a>
						</li> -->
					</ul>
				</div>
			</li>
<!-- <li ngbDropdown class="nav-item language"> <a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic3" ngbDropdownToggle><i class="flag-icon flag-icon-gb align-middle"></i></a>
				<ul ngbDropdownMenu aria-labelledby="dropdownBasic3" class="dropdown-menu-right">
					<li ngbDropdownItem><i class="flag-icon flag-icon-gb mr-3"></i>English</li>
					<li ngbDropdownItem><i class="flag-icon flag-icon-fr mr-3"></i>French</li>
					<li ngbDropdownItem><i class="flag-icon flag-icon-cn mr-3"></i>Chinese</li>
					<li ngbDropdownItem><i class="flag-icon flag-icon-de mr-3"></i>German</li>
				</ul>
			</li> -->

			<!-- <li> 
				<a class="nav_bar_menu" [routerLink]="['/dashboard/dashboard']" id="dashboard">Dashboard</a>
			</li> -->

			<!-- <li> 
				<a class="nav_bar_menu" [routerLink]="['/pages/live-panel']" id="live_panel">Live Panel</a>
			</li> -->

			<li ngbDropdown class="nav-item">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic4" ngbDropdownToggle> <span class="user-profile"><img src="assets/images/avatars/default_avatar.png" class="img-circle" alt="user avatar"></span>
				</a>
				<ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
					<li ngbDropdownItem class="user-details">
						<a href="javaScript:;">
							<div class="media">
								<div class="avatar">
									<img class="align-self-start mr-3" src="assets/images/avatars/default_avatar.png" alt="user avatar">
								</div>
								<div class="media-body">
									<h6 class="mt-2 user-title">{{fullName}}</h6>
									<p class="user-subtitle">{{email}}</p>
								</div>
							</div>
						</a>
					</li>
					<!-- <li class="dropdown-divider"></li>
					<li ngbDropdownItem><i class="zmdi zmdi-comments mr-3"></i>Inbox</li>
					<li class="dropdown-divider"></li>
					<li ngbDropdownItem><i class="zmdi zmdi-balance-wallet mr-3"></i>Account</li> -->
					<li class="dropdown-divider"></li>
					<!-- <a [routerLink]="['/form/profile-page']"><li ngbDropdownItem><i class="zmdi zmdi-settings mr-3"></i>My Profile</li></a> -->
					<a><li ngbDropdownItem><i class="zmdi zmdi-settings mr-3"></i>My Profile</li></a>

					<li class="dropdown-divider"></li>
					<a [routerLink]="['/auth/signin']" (click)="logout()"><li ngbDropdownItem><i class="zmdi zmdi-power mr-3"></i>Logout</li></a>
				</ul>
			</li>
		</ul>
	</nav>
</header>

<div class="modal left" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content">

			<div class="modal-header">
				<h5>Document Notifications</h5>
				<button type="button" class="close" (click)="UpdateAndShowNotification()" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
			</div>

			<div class="modal-body">
				<div class="row">
					<div class="col-lg-12">
						<div class="card">
							<form action="#" #documentExpiryAlertsForm="ngForm"> 
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover">
										<thead>
											<tr>
												<th>Sr. No.</th>
												<th>Vehicle/driver/conductor</th>
												<th>Document Name</th>
												<th>Expiry Date</th>
												<!-- <th>Seen By</th> -->
											  </tr>
										</thead>
										<tbody>
										   <tr *ngFor="let alert of popupRowData; let i = index">
											<th scope="row">{{i+1}}</th>
											<td *ngIf="alert.employeeId!=0">{{alert.employeeName}}</td>
											<td *ngIf="alert.employeeId==0">{{alert.vehicleName}}</td>
											<td>{{alert.documentName}}</td>
											<td>{{alert.expiryDate | date:'dd-MM-yyyy'}}</td>
											<!-- <td>{{alert.seenUsername}}</td> -->
										</tr>
										</tbody>
									</table>
								</div>
							 </div>
						  </form>
						</div>
					</div>
				</div>
			</div>

		</div><!-- modal-content -->
	</div><!-- modal-dialog -->
</div><!-- modal -->

<div class="modal left" id="serviceModal" tabindex="-1" role="dialog" aria-labelledby="serviceModalLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content">

			<div class="modal-header">
				<h5>Service Notifications</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
			</div>

			<div class="modal-body">
				<div class="row">
					<div class="col-lg-12">
						<div class="card">
							<form action="#" #serviceAlertsForm="ngForm"> 
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover">
										<thead>
											<tr>
												<th>Route No.</th>
												<th>Device Name</th>
												<th style="min-width: 90px;">Last Service Date</th>
												<th style="min-width: 95px;">Last Service KM</th>
												<th>Current Service KM</th>
												<th>Running KM</th>
												<th>Alert Date</th>
											</tr>
										</thead>
										<tbody>
										   	<tr *ngFor="let sd of serviceData; let i = index">
												<td>{{sd.routeNo}}</td>
												<td>{{sd.deviceName}}</td>
												<td>{{sd.lastServiceDate | date:'dd-MM-yyyy'}}</td>
												<td>{{sd.lastServiceKm}}</td>
												<td>{{sd.currentServiceKm}}</td>
												<td>{{sd.runningKm}}</td>
												<td>{{sd.serviceAlertDate | date:'dd-MM-yyyy'}}</td>
											</tr>
										</tbody>
									</table>
								</div>
							 </div>
						  </form>
						</div>
					</div>
				</div>
			</div>

		</div><!-- modal-content -->
	</div><!-- modal-dialog -->
</div><!-- modal -->

<div class="modal left" id="blackoutModal" tabindex="-1" role="dialog" aria-labelledby="blackoutModalLabel">
	<div class="modal-dialog" style="min-width: 1100px;">
		<div class="modal-content">
			<div class="modal-header" style="height: 50px;">
				<h5>Blackout Notification</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
			</div>
			<div class="modal-body" style="padding:5px;">
				<div class="row">
					<div class="col-lg-12">
						<!-- <div class="card"> -->
							<form action="#" #blackoutAlertsForm="ngForm"> 
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover" style="margin-bottom:0px;">
										<thead >
											<tr >
												<th style="padding: 5px; text-align: center;">Employee Name</th>
												<th style="padding: 5px; text-align: center;">Mobile No.</th>
												<th style="padding: 5px; text-align: center;">Designation</th>
												<th style="padding: 5px; text-align: center;min-width:170px;">Attendance Date Time</th>
												<th style="padding: 5px; text-align: center;min-width:170px;">Start Blackout Time</th>
												<th style="padding: 5px; text-align: center;min-width:170px;">End Blackout Time</th>
												<th style="padding: 5px; text-align: center;min-width:100px;">Total Time</th>
											</tr>
										</thead>
										<tbody>
										   	<tr *ngFor="let bo of boRowData; let i = index">
												<td>{{bo.employeeNo[0]}} {{bo.firstName[0]}} {{bo.lastName[0]}}</td>
												<td>{{bo.mobileNo}}</td>
												<td>{{bo.designationName}}</td>
												<td>{{bo.punchInTime | date:'dd-MM-yyyy HH:mm:ss'}}</td>
												<td>{{bo.lastBlackOutTime | date:'dd-MM-yyyy HH:mm:ss'}}</td>
												<td>{{bo.currentBlackOutTime | date:'dd-MM-yyyy HH:mm:ss'}}</td>
												<td>{{bo.blackOutTimeHours}}:{{bo.blackOutTimeMinutes}}</td>
											</tr>
										</tbody>
									</table>
								</div>
							 
						  </form>
						<!-- </div> -->
					</div>
				</div>
			</div>

		</div><!-- modal-content -->
	</div><!-- modal-dialog -->
</div><!-- modal -->


<div class="modal left" id="empRemainderModal"  role="dialog" >
	<div class="modal-dialog" style="min-width: 550px;">
    <div class="modal-content">
            <div class="modal-header bday header">
                <h4 class="modal-title" id="myModalLabel">Employee Birthday Remainder </h4>
                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
            </div>
            <div  class="modal-body bday" >
				<section class="">
					<div class="frame container ">
						<div class="bday_card_body p-3 text-center">
							<div class="d-flex justify-content-between bday_card_hedear bday_card_top">
								<img src="../../../assets/images/logo.png" alt="" srcset="" width="100"  class="img-flud">   
							</div>
							<div class="bday_card_mid mt-1">
								<img src="../../../assets/images/bday_logo.png" alt="" srcset="" width="200"  class="img-flud">
								<div class="bday_card_name">
									<h4><span id="birthdayEmployeeName"></span></h4>
									<p><span id="birthdayDesignation"></span></p>
								</div>
								<div class="bday_card_text mt-2"> 
									<p>
										“ On  behalf  of  the  entire  Company , <br>
										We  wish  you  a   very <strong>Happy Birthday</strong><br>
										and  Send  you   best  wishes  for  much  <br>
									   <strong>Happiness</strong> in your life “  </p>
								</div>
							</div>
							<div class="bday_card_footer d-flex justify-content-center mt-5">
								<p>Incubate Soft Tech PVT.  LTD.</p>
							</div>

							<!-- <div class="row">
							<div class="col-md-6 mt-3">
								<p style="text-align: left;"><i class="fa fa-map-marker" aria-hidden="true">Bhopal</i></p>
							</div>
							<div class="col-md-6 mt-3">
								<p style="text-align: right;"><i class="fa fa-phone" aria-hidden="true">6262604343</i></p>
							</div>
							</div> -->
			
						</div>
					</div>
				</section>
              </div>
        <div class="modal-footer bday">
			<!-- <button> <a href="https://web.whatsapp.com/send?text=www.google.com" data-text="Take a look at this awesome website:" class="wa_btn wa_btn_s" style="display:none">Share1</a></button> -->
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DownloadAsImage()">Save</button>
			<button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
        </div>
    </div>
    </div>
</div>

<!-- <div class="modal left" id="empRemainderModal"  role="dialog" >
	<div class="modal-dialog" >
    <div class="modal-content">
            <div class="modal-header header">
                <h4 class="modal-title" id="myModalLabel">Employee Birthday Remainder </h4>
                <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
            </div>
            <div  class="modal-body" >
                 <table id="tableData" class="table table-bordered target_tbl">
						<thead>
							<tr>
								<th>Employee Code</th>
								<th>Employee Name</th>
								<th>Designation</th>
								<th style="min-width: 100px;">DOB</th>
								<th>Contact No</th>
							  </tr>
						</thead>
						<tbody>
							<tr *ngFor="let rem of bdRowData  let i = index">
								<td>{{rem.employeeNo}}</td>
								<td>{{rem.firstName}} {{rem.lastName}}</td>
								<td>{{rem.designationName[0]}}</td>
								<td>{{rem.dob}}</td>
								<td>{{rem.contact}}</td>
							</tr>
						</tbody>
					</table>
              </div>
        <div class="modal-footer ">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
        </div>
    </div>
    </div>
</div> -->

<!--End topbar header-->